import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { WrapperCollegamentoUnitaDocumentariaDTO } from "../dto/wrapper-collegamento-unita-documentariaDTO";
import { WrapperCollegamentoUnitaDocumentariaVO } from "../vo/wrapper-collegamento-unita-documentariaVO";
import { MapperClassifica } from "./mapper-classifica";
import { MapperUtente } from "./mapper-utente";

import { MapperVisibilitaFascicolo } from "./mapper-visibilita-fascicolo";
import { MapperRiferimentiPosizione } from "./mapper-riferimenti-posizione";
import { WrapperCollegamentoFascicoloDTO } from "../dto/wrapper-collegamento-fascicoloDTO";
import { WrapperCollegamentoFascicoloVO } from "../vo/wrapper-collegamento-fascicoloVO";
import { MapperTipoIstanzaFascicolo } from "./mapper-tipo-istanza-fascicolo";
import { MapperSettore } from "./mapper-settore";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";

@Injectable({
  providedIn: "root",
})
export class MapperWrapperCollegamentoFascicolo
  implements
    MapperInterface<
      WrapperCollegamentoFascicoloDTO,
      WrapperCollegamentoFascicoloVO
    > {
  constructor(
    private mapperClassifica: MapperClassifica,
    private mapperUtente: MapperUtente,
    private mapperVisibilitaElemento: MapperVisibilitaFascicolo,
    private mapperRiferimentoPosizione: MapperRiferimentiPosizione,
    private mapperTipoInstanza: MapperTipoIstanzaFascicolo,
    private mapperStruttura: MapperSettore,
    private mapperMetadatiRepertorio: MapperMetadatiRepertorio
  ) {}

  convertVoToDto(
    vo: WrapperCollegamentoFascicoloVO
  ): WrapperCollegamentoFascicoloDTO {
    if (vo != null) {
      const dto = new WrapperCollegamentoFascicoloDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.id = vo.id;
      dto.classifica = this.mapperClassifica.convertVoToDto(vo.classifica);
      //dto.dataUltimaModifica = vo.dataUltimaModifica;
      dto.inseritoDa = dto.inseritoDa = this.mapperUtente.convertVoToDto(
        vo.inseritoDa
      );
      dto.oggetto = vo.oggetto;
      dto.segnaturaArchivistica = vo.segnaturaArchivistica;
      dto.stato = vo.stato;
      dto.visibilitaElemento = this.mapperVisibilitaElemento.convertListVoToDto(
        vo.visibilitaElemento
      );
      dto.tipologia = this.mapperTipoInstanza.convertVoToDto(vo.tipologia);
      dto.riferimentoPosizione = this.mapperRiferimentoPosizione.convertVoToDto(
        vo.riferimentoPosizione
      );
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(
    dto: WrapperCollegamentoFascicoloDTO
  ): WrapperCollegamentoFascicoloVO {
    if (dto != null) {
      const vo = new WrapperCollegamentoFascicoloVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.id = dto.id;
      vo.classifica = this.mapperClassifica.convertDtoToVo(dto.classifica);
      //vo.dataUltimaModifica = dto.dataUltimaModifica;
      vo.inseritoDa = this.mapperUtente.convertDtoToVo(dto.inseritoDa);
      vo.oggetto = dto.oggetto;
      vo.segnaturaArchivistica = dto.segnaturaArchivistica;
      vo.dataApertura = dto.dataApertura;
      vo.visibilitaElemento = this.mapperVisibilitaElemento.convertListDtoToVo(
        dto.visibilitaElemento
      );
      vo.strutturaResponsabile = this.mapperStruttura.convertDtoToVo(
        dto.strutturaResponsabile
      );

      if (dto.stato == "IN_LAVORAZIONE") {
        vo.stato = "IN LAVORAZIONE";
      } else {
        vo.stato = dto.stato;
      }
      vo.tipologia = this.mapperTipoInstanza.convertDtoToVo(dto.tipologia);
      vo.riferimentoPosizione = this.mapperRiferimentoPosizione.convertDtoToVo(
        dto.riferimentoPosizione
      );
      vo.segnatura = dto.segnatura;
      vo.visibilitaFascicolo = this.mapperVisibilitaElemento.convertListDtoToVo(
        dto.visibilitaFascicolo
      );
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: WrapperCollegamentoFascicoloVO[]
  ): WrapperCollegamentoFascicoloDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(
    dtoList: WrapperCollegamentoFascicoloDTO[]
  ): WrapperCollegamentoFascicoloVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
